import styled from '@emotion/styled';
import { exceptStyledProps, setDeclaration } from '../../utils';

export const Svg = styled('svg', exceptStyledProps('width', 'height', 'color'))`
  flex-shrink: 0;
  color: ${props => props.color};
  vertical-align: middle;
  fill: currentColor;

  ${props => setDeclaration('width', props.width, 'rem')};
  ${props => setDeclaration('height', props.height, 'rem')};
`;
